import { render, staticRenderFns } from "./SporBahisIslemleri.vue?vue&type=template&id=306648cc&scoped=true"
import script from "./SporBahisIslemleri.vue?vue&type=script&lang=js"
export * from "./SporBahisIslemleri.vue?vue&type=script&lang=js"
import style0 from "./SporBahisIslemleri.vue?vue&type=style&index=0&id=306648cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306648cc",
  null
  
)

export default component.exports